import { createSlice } from "@reduxjs/toolkit";
import { EmailAddress } from "../../emailTopics/models/EmailAddress";
import { EmailAddressTopic } from "../../emailTopics/models/EmailAddressTopic";
import { EmailTopic } from "../../emailTopics/models/EmailTopic";

const EmailAddressesInitialState: {
	addresses: EmailAddress[];
	addressSelected: EmailAddress | null;
	topics: EmailTopic[];
	// GetEmailAddresses returns the topic names, which is what the grid shows. The edit form needs
	// their ids, and those only come in the second result set of GetEmailTopics.
	addressTopics: EmailAddressTopic[];
} = {
	addresses: [],
	addressSelected: null,
	topics: [],
	addressTopics: [],
};

export const EmailAddressesReducer = createSlice({
	name: "__",
	initialState: EmailAddressesInitialState,
	reducers: {
		setAddresses(state, { payload }) {
			state.addresses = payload;
		},
		setAddressSelected(state, { payload }) {
			state.addressSelected = payload;
		},
		setTopics(state, { payload }) {
			state.topics = payload;
		},
		setAddressTopics(state, { payload }) {
			state.addressTopics = payload;
		},
	},
});
